export default __webpack_public_path__ + "static/media/engage.22970d06.svg";